import {NgModule, ComponentFactoryResolver, ComponentFactory} from '@angular/core';
import {MatIconModule} from '@cdk/angular/material';
import {CommonModule} from '@angular/common';
import {SearchBarComponent} from './search-bar.component';

@NgModule({
    declarations: [
        SearchBarComponent
    ],
    imports: [
        MatIconModule,
        CommonModule,
    ],
    providers: [],
    exports: [
        SearchBarComponent
    ]
})
export class SearchBarModule {

    constructor(private resolver: ComponentFactoryResolver) {}

    public resolveComponentFactory(): ComponentFactory<SearchBarComponent> {
        return this.resolver.resolveComponentFactory(SearchBarComponent);
    }
}
